import React from 'react'
import '../about/About.css'
import Client from './Client'
export default function Hire() {
  return (
    <div id='hire-page'>
        <h1 id='heading' className='hire-head'>Hire With us!</h1>
        <Client />
    </div>
  )
}
